/**
 * number validation
 */

export const numberRegex = /^[aA-zZ]+[0-9]*$/;

/**
 * valid phone number
 */

export const mobileNumberRegx = /(^(9)([6,7,8])([0-9]{8})$)/;

/**
 * valid email
 */

export const emailRegx =
	/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

/**
 * Password validation
 */

export const passwordRegx =
	/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm;
